import routes from "../../common/api-routes";
import {HttpAuthGet, HttpAuthPost, HttpAuthPut, HttpAuthPut1} from "../../../../../core/services/common/HttpRequestBuilder"
import { HttpActualPut1 } from "../../../../../core/services/common/HttpCoreOperation";


const getUserProfile = (parameters) => {

    let result = HttpAuthGet(routes.GET_USER_PROFILE, parameters);
    return result;
}

const updateProfile = (parameters, payload) => {

    let result = HttpAuthPut1(routes.UPDATE_PROFILE, parameters, payload);
    return result;
}

const updateProfileStatus = (parameters, payload) => {

    let result = HttpAuthPut1(routes.UPDATE_PROFILE_STATUS, parameters, payload);
    return result;
}

const viewUserProfile = (parameters) => {

    let result = HttpAuthGet(routes.VIEW_USER_PROFILE, parameters);
    return result;
}


const ProfileService = {
    getUserProfile,
    updateProfile,
    updateProfileStatus,
    viewUserProfile
}

export default ProfileService
